export const CONTACT_FULL_ROUTE = 'contacts/:id/:cbTabRouteId';
